import React from "react";
import { useNavigate } from "react-router-dom";
import { setDate } from "../../Utils/helper";

export const DashBoardBanner = ({ message, button, navigateto, lastUploadDate }) => {

    const steps = [
        {
            id: 1,
            text: "Select Template"
        },
        {
            id: 2,
            text: "Select manual/bulk"
        },
        {
            id: 3,
            text: "Add Recepients Details"
        },
        {
            id: 4,
            text: "Publish Document"
        }
    ]

    const navigate = useNavigate()
    return (
        <div className="verifierTopcontainer">
            <div className='verifierContainer'>
                <div><h2 className='VerifierStepHeader'>{message}</h2></div>
                <div className='heading'>How it works</div>
                <div className='StepMainContainer'>
                    {steps.map((i, index) =>
                    (<div className='StepContainer' key={index}>
                        <div className='VerifierStepsContainer'><span className='VerifierSteps'>{i.id}</span>
                            <span className='VerifierStepcontent'> {i.text} </span></div>
                        {i.id == 4 ? null :
                            <div style={{ textAlign: "center" }}><img src='/chevron-right-gray.svg' alt='chevronRightgray.svg' className='right-icon' /></div>}
                    </div>)
                    )}
                </div>
            </div>
            <div className="verifierContainer">
{lastUploadDate&&          <div className="last-uploaded-container">
  <svg xmlns="http://www.w3.org/2000/svg" 
       fill="none" viewBox="0 0 24 24" 
       stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" 
          d="M12 6v6l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>

  <p className="last-uploaded-text">
    <strong>Last Record Uploaded On:</strong>
    <span className="last-uploaded-date">{setDate(lastUploadDate)}</span>
  </p>
</div>}
                <div style={{textAlign:"right"}}>
                <button className='btn btn-primary' onClick={() => navigate(navigateto)}>{button}</button>
                </div>
            </div>

        </div>

    )
}